export default __webpack_public_path__ + "static/media/KneeExtensionPreswing.2ff69e17.png";